import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import mixpanel from 'mixpanel-browser';
import { jwtDecode } from 'jwt-decode';

import { get, set } from './global.service';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    token: string;
    constructor(
        private httpClient: HttpClient //
    ) { }

    loadConfig(): Promise<void> {
        return new Promise(resolve => {
            const baseUrl = '.';
            this.httpClient.get(`${baseUrl}/assets/JSONs/app.config.json`).subscribe({
                next: (resp: any) => {
                    Object.keys(resp).forEach(key => set(key, resp[key]));
                    set('baseUrl', baseUrl);
                    resolve();
                },
                error: (err: any) => {
                    console.error(err);
                    resolve();
                }
            });
        });
    }

    isSignalRTokenValid(): boolean {
        const token = get('signalRAccessToken');
        if (!token) return false;
        try {
            const decoded = jwtDecode(token);
            // Consider invalid if it expires within 60 seconds
            return (decoded?.exp ?? 0) > Math.floor(Date.now() / 1000) + 60;
        } catch {
            return false;
        }
    }

    async ensureValidSignalRToken(): Promise<void> {
        if (!this.isSignalRTokenValid()) {
            await this.loadHubData();
        }
    }

    loadHubData(): Promise<void> {
        return new Promise(resolve => {
            this.httpClient.post(`${get('hubSignalrUrl')}`, null, { headers: { 'Access-Control-Allow-Origin': '*' } }).subscribe({
                next: (resp: any) => {
                    set('signalRUrl', resp.Url);
                    set('signalRAccessToken', resp.AccessToken);
                    const delay = (jwtDecode(resp.AccessToken)?.exp - Math.floor(Date.now() / 1000) - 300) * 1000;
                    if (delay > 0) setTimeout(() => this.loadHubData(), delay);
                    resolve();
                },
                error: (err: any) => {
                    setTimeout(() => this.loadHubData(), 10000);
                    resolve();
                }
            });
        });
    }

    mixPanelInit(): Promise<void> {
        return new Promise((resolve) => {
            const token = get('mixPanelToken');
            if (token) mixpanel.init(token);
            resolve();
        });

    }
}
